/* Fan Club — buy box free-shipping progress + add-another strip.
   Keeps the progress bar in step with the real cart: updates after its own
   adds, and subscribes to Dawn's cartUpdate so the main Add to cart counts too. */
class FcShippingUpsell extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bound) return;
    this.dataset.bound = '1';

    this.threshold = parseInt(this.dataset.threshold, 10) || 0;
    this.moneyFormat = this.dataset.moneyFormat || '£{{amount}}';

    this.addEventListener('click', this.onClick);
    this.addEventListener('change', this.onChange);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.syncFromCart());
    }
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }

  formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    const [whole, dec] = value.split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return this.moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, `${grouped}.${dec}`)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${grouped.replace(/,/g, '.')},${dec}`)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, grouped)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, grouped.replace(/,/g, '.'));
  }

  syncFromCart() {
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart.js`)
      .then((r) => r.json())
      .then((cart) => this.render(cart.total_price))
      .catch((e) => console.error('[fc-shipping-upsell]', e));
  }

  render(totalPrice) {
    if (this.dataset.showBar !== 'true' || !this.threshold) return;
    const fill = this.querySelector('[data-fcsu-fill]');
    const text = this.querySelector('[data-fcsu-text]');
    const track = this.querySelector('.fcsu__track');
    if (!fill || !text) return;

    const remaining = this.threshold - totalPrice;
    const pct = Math.min(100, Math.round((totalPrice * 100) / this.threshold));
    const wasUnlocked = this.classList.contains('is-unlocked');

    fill.style.width = `${pct}%`;
    if (track) track.setAttribute('aria-valuenow', pct);

    if (remaining <= 0) {
      text.innerHTML = `<strong>${this.dataset.unlockedText || 'Free delivery unlocked'}</strong>`;
      this.classList.add('is-unlocked');
      // replay the celebratory pop only on the transition into unlocked
      if (!wasUnlocked && track && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        track.style.animation = 'none';
        void track.offsetWidth;
        track.style.animation = '';
      }
    } else {
      text.innerHTML = `${this.dataset.progressText || ''} <strong>${this.formatMoney(remaining)}</strong> ${this.dataset.progressSuffix || ''}`;
      this.classList.remove('is-unlocked');
    }
  }

  onChange = (event) => {
    const select = event.target.closest('[data-fcsu-select]');
    if (!select) return;
    const price = select.options[select.selectedIndex]?.dataset.price;
    const priceEl = select.closest('.fcsu__card')?.querySelector('.fcsu__card-price');
    if (price && priceEl) priceEl.innerHTML = price;
  };

  onClick = (event) => {
    const scroller = event.target.closest('[data-fcsu-scroll]');
    if (scroller) {
      const rail = this.querySelector('.fcsu__rail');
      const card = rail?.querySelector('.fcsu__card');
      if (rail && card) {
        rail.scrollBy({
          left: parseInt(scroller.dataset.fcsuScroll, 10) * (card.offsetWidth + 10) * 2,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
      return;
    }
    const button = event.target.closest('[data-fcsu-add]');
    if (button) this.add(button);
  };

  add(button) {
    const card = button.closest('.fcsu__card');
    const select = card?.querySelector('.fcsu__card-select');
    const variantId = parseInt(select?.value, 10);
    if (!variantId) return;

    const errorBox = this.querySelector('[data-fcsu-err]');
    if (errorBox) errorBox.hidden = true;

    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status) throw new Error(data.description || data.message || 'Could not add');
        button.textContent = 'Added';
        button.classList.add('is-added');
        this.syncFromCart();
        this.refreshCartIcon(root);
        setTimeout(() => {
          button.textContent = original;
          button.classList.remove('is-added');
          button.disabled = false;
        }, 2000);
      })
      .catch((e) => {
        console.error('[fc-shipping-upsell]', e);
        button.disabled = false;
        button.textContent = original;
        if (errorBox) {
          errorBox.textContent = "Sorry, that couldn't be added. Please try again.";
          errorBox.hidden = false;
        }
      });
  }

  refreshCartIcon(root) {
    fetch(`${root}?section_id=cart-icon-bubble`)
      .then((r) => r.text())
      .then((html) => {
        const bubble = document.getElementById('cart-icon-bubble');
        const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (bubble && parsed) bubble.innerHTML = parsed.innerHTML;
      })
      .catch(() => {});
  }
}

customElements.define('fc-shipping-upsell', FcShippingUpsell);
